import currency from 'onyx-common/currency-js'

const formatCurrency = (val) => {
  return currency(val).format()
}

export default formatCurrency
